var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampanaNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.065,
    height: 26.479,
    viewBox: "0 0 22.065 26.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_633816",
    "data-name": 633816,
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_240",
    "data-name": "Grupo 240",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_239",
    "data-name": "Grupo 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75",
    "data-name": "Trazado 75",
    d: "M64.662,22.333l-1.894-3.158A9.379,9.379,0,0,1,61.43,14.35V11.584a7.733,7.733,0,0,0-5.517-7.4V2.207a2.207,2.207,0,0,0-4.413,0v1.98a7.733,7.733,0,0,0-5.516,7.4V14.35a9.385,9.385,0,0,1-1.336,4.825l-1.894,3.158a.553.553,0,0,0,.472.836H64.189a.551.551,0,0,0,.473-.835Z",
    transform: "translate(-42.675)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_242",
    "data-name": "Grupo 242",
    transform: "translate(7.558 24.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_241",
    "data-name": "Grupo 241",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76",
    "data-name": "Trazado 76",
    d: "M188.815,469.333a3.838,3.838,0,0,0,6.949,0Z",
    transform: "translate(-188.815 -469.333)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampanaNavbar);
export default __webpack_public_path__ + "static/media/campana-navbar.92853c13b9450f6458781ae8c04fdcf3.svg";
export { ForwardRef as ReactComponent };